import Alert from 'react-bootstrap/Alert'

function ToastMessage({ message, variant = 'warning' }) {
  return (
    <Alert variant={variant} className='d-flex align-items-center justify-content-center'>
      {message}
    </Alert>
  )
}

export default ToastMessage
